import { render, staticRenderFns } from "./GenericPaymentLayout.vue?vue&type=template&id=039a7a36&"
import script from "./GenericPaymentLayout.vue?vue&type=script&lang=js&"
export * from "./GenericPaymentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports